import { el, setAttr, setChildren } from 'redom';

import { buildButtonAttributes, getIconByName } from './utilities';

import iconNames from './icon-names';

class SecondLevelCTA {

  constructor(options) {

    this.label = el('span', options.label);

    this.el = el('button',
      buildButtonAttributes(options),
      [getIconByName(options.icon), this.label]
    );

  }

  setReadOnly(readOnly) {

    setAttr(this.el, {
      disabled: readOnly
    });

  }

  disable() {

    this.setReadOnly(true);

  }

  enable() {

    this.setReadOnly(false);

  }

  setLabel(label) {

    this.label.textContent = label;

  }

  setIcon(icon) {

    setChildren(this.el, [getIconByName(icon), this.label]);

  }

  addClass(cls) {
    this.el.classList.add(cls);
  }

  removeClass(cls) {
    this.el.classList.remove(cls);
  }

  hide() {

    setAttr(this.el, { style: { display: 'none' } });

  }

  show() {

    setAttr(this.el, { style: { display: 'flex' } });

  }

  update() {}

}

SecondLevelCTA.icons = iconNames;

export default SecondLevelCTA;